import { RootState } from "@/config/store";
import { setEvent } from "@/services/dashboard/Download_Slice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
}

export const useDownloadApp = () => {

    const event = useSelector((state: RootState) => state.downloadEvent).event;
    const dispatch: ThunkDispatch<any, any, any> = useDispatch();
    // const [deferredPrompt, setDeferredPrompt] = useState<BeforeInstallPromptEvent | null>(null);

    const showPrompt = async () => {
        console.log("Showing install prompt...", event);
        if (!event) return;

        console.log("Showing install prompt...");
        await event?.prompt();

        const result = await event?.userChoice;
        console.log(`Install prompt outcome: ${result?.outcome}`);

        // setDeferredPrompt(null); 
    };

    useEffect(() => {
        const handleBeforeInstallPrompt = (event: BeforeInstallPromptEvent) => {
            event.preventDefault();
            dispatch(setEvent(event));
            // setDeferredPrompt(event);
        };

        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt as EventListener);

        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt as EventListener);
        };
    
    }, []);

    return { showPrompt, isInstallable: !!event };
};
